import {
    faArrowPointer,
    faBan,
    faBoxHeart,
    faMailboxFlagUp,
    faXmarkToSlot,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as MetricCard from 'assets/js/pages/engage/metrics/MetricCard';
import { useCurrentEngageMessage } from 'customHooks/useCurrentEngageMessage';

const EngageMetricsCards = () => {
    const { data: message } = useCurrentEngageMessage();

    return (
        <div className="grid grid-cols-3 gap-4 md:grid-cols-5">
            <MetricCard.Root>
                <MetricCard.Content>
                    <MetricCard.Header>
                        <MetricCard.Title>Revenue Generated</MetricCard.Title>
                        <MetricCard.Icon>
                            <FontAwesomeIcon
                                className="text-brand-cobalt-primary"
                                icon={faBoxHeart}
                            />
                        </MetricCard.Icon>
                    </MetricCard.Header>
                    <MetricCard.Value>
                        ${message.revenue_generated?.toLocaleString()}
                    </MetricCard.Value>
                </MetricCard.Content>
            </MetricCard.Root>

            <MetricCard.Root>
                <MetricCard.Content>
                    <MetricCard.Header>
                        <MetricCard.Title>Open Rate</MetricCard.Title>
                        <MetricCard.Icon>
                            <FontAwesomeIcon className="text-success-600" icon={faMailboxFlagUp} />
                        </MetricCard.Icon>
                    </MetricCard.Header>
                    <MetricCard.Value>{message.stats.open_rate.toLocaleString()}%</MetricCard.Value>
                </MetricCard.Content>
            </MetricCard.Root>

            <MetricCard.Root>
                <MetricCard.Content>
                    <MetricCard.Header>
                        <MetricCard.Title>Click to Open Rate</MetricCard.Title>
                        <MetricCard.Icon>
                            <FontAwesomeIcon
                                className="text-brand-cobalt-primary"
                                icon={faArrowPointer}
                            />
                        </MetricCard.Icon>
                    </MetricCard.Header>
                    <MetricCard.Value>
                        {message.stats.bounce_rate.toLocaleString()}%
                    </MetricCard.Value>
                </MetricCard.Content>
            </MetricCard.Root>

            <MetricCard.Root>
                <MetricCard.Content>
                    <MetricCard.Header>
                        <MetricCard.Title>Bounces</MetricCard.Title>
                        <MetricCard.Icon>
                            <FontAwesomeIcon className="text-black" icon={faXmarkToSlot} />
                        </MetricCard.Icon>
                    </MetricCard.Header>
                    <MetricCard.Value>
                        {message.stats.bounce_count.toLocaleString()}
                    </MetricCard.Value>
                </MetricCard.Content>
            </MetricCard.Root>

            <MetricCard.Root>
                <MetricCard.Content>
                    <MetricCard.Header>
                        <MetricCard.Title>Unsubscribe</MetricCard.Title>
                        <MetricCard.Icon>
                            <FontAwesomeIcon className="text-warning-600" icon={faBan} />
                        </MetricCard.Icon>
                    </MetricCard.Header>
                    <MetricCard.Value>
                        {message.stats.unsubscribe_count.toLocaleString()}
                    </MetricCard.Value>
                </MetricCard.Content>
            </MetricCard.Root>
        </div>
    );
};

export { EngageMetricsCards };
